module.exports = {
  content: {
    noProductsTip: "There is no brand in this category~",
    allbrands: "ALL BRANDS",
    allproducts: "All Products",
    brand: "Brand",
    condition: "Condition",
    sorting: "Sorting",
    price: "Price",
    yourSearch: "Your Search: ",
    favoriteBrand: "Choose Your Favorite Brand",
    viewllBrands: "View All Brands",
    advancedOptions: "Advanced Options",
    searchContent: "Please enter content",
    noProductTitle: "There are no products in this category.",
    noProductContent: `Sorry, There are no products in this category.Please wait patiently for 
    the improvement of our products.`,
    noSearchTitle: "No results for your search.",
    noSearchContent: `Sorry, the related item you searched for was not found.`,
    noShopTitle: "There is nothing in this store.",
    noShopContent: `Go back to the homepage and browse around, the products there may satisfy you.`,
    noResult: `<p>No results.<br />
    - Check your spelling for typing errors.<br />
    - Try searching with short and simple keywords.<br />
    - Try searching more general terms - you can then filter the search results.</p>`
  }
}


// WEBPACK FOOTER //
// ./src/assets/lang/en-us/classify/index.js